import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { faCopy, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Company } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { Loader } from '../Widgets';
import { NavLink } from 'react-router-dom';

export const BankDetails = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [company, setCompany] = useState<Company>();

    useEffect(() => {
        if (user.profile) {
            fetchCompanyDetails();
        }
    }, [user]);

    const fetchCompanyDetails = () => {
        const cachedCompany = sessionStorage.getItem("company");
        if (cachedCompany) {
            setCompany(JSON.parse(cachedCompany));
            setIsLoading(false);
        }
        else {
            ArthaGateway
                .getCompany(1)
                .then((data) => {
                    setCompany(data);
                    sessionStorage.setItem("company", JSON.stringify(data));
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <div className="page page-bank-details">
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='card mb-2'>
                                <div className='card-background'></div>
                                <div className='card-header bg-dark text-white'>
                                    <h5 className="card-title">Bank Details</h5>
                                </div>
                                <div className="card-body">
                                    {company &&
                                        <p className="card-text">
                                            <b>{company.name}</b><br />
                                            Bank Name: <b>{company?.bankAccount?.bankName}</b><br />
                                            Branch: <b>{company?.bankAccount?.branch}</b><br />
                                            IFSC Code: <b>{company?.bankAccount?.ifscCode}</b>
                                            <div className="btn" onClick={() => { navigator.clipboard.writeText(company?.bankAccount?.ifscCode) }} style={{ padding: "0 0 0 10px" }}>
                                                <FontAwesomeIcon icon={faCopy} style={{ width: "auto" }} />
                                            </div>
                                            <br />
                                            Account No: <b>{company?.bankAccount?.accountNumber}</b>
                                            <div className="btn" onClick={() => { navigator.clipboard.writeText(company?.bankAccount?.accountNumber) }} style={{ padding: "0 0 0 10px" }}>
                                                <FontAwesomeIcon icon={faCopy} style={{ width: "auto" }} />
                                            </div>
                                            <br />
                                            UPI: <b>{company?.bankAccount?.upiId}</b>
                                            <div className="btn" onClick={() => { navigator.clipboard.writeText(company?.bankAccount?.upiId) }} style={{ padding: "0 0 0 10px" }}>
                                                <FontAwesomeIcon icon={faCopy} style={{ width: "auto" }} />
                                            </div>
                                        </p>
                                    }
                                </div>
                                <div className='card-footer'>
                                    <NavLink to="/payment" className="btn btn-primary w-100">
                                        <FontAwesomeIcon icon={faCreditCard} style={{ width: "auto" }} />
                                        &nbsp; Make Payment
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <NavLink to="/" className="btn btn-danger btn-lg w-100">
                                Back
                            </NavLink>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}